// extracted by mini-css-extract-plugin
export default {"root":"SiteNavigation_root__FnlCc","logo":"SiteNavigation_logo__iYlGT","logoutMenu":"SiteNavigation_logoutMenu__CYBoi"};